// extracted by mini-css-extract-plugin
export default {"AffichageAcceptationCgv":"AffichageAcceptationCgv_AffichageAcceptationCgv__4uB-P","Boutons":"AffichageAcceptationCgv_Boutons__Sa9ZI"};